import type { AxiosResponse } from "axios";
import type { HttpClient } from "@/services/baseClient";
import type { ApiResponse, AdminRecordingWatchResponse } from "@/types";

export function createAdminWatchApi({ client }: HttpClient) {
  return {
    /**
     * Admin-only watch payload for one recording (JWT + ADMIN_EMAILS
     * allowlist on the backend). Returns the RecordingSummary-shaped
     * recording — with a freshly minted playback token — plus light session
     * context for the page header.
     */
    async getAdminRecordingWatch(
      recordingId: string,
    ): Promise<AdminRecordingWatchResponse> {
      const response: AxiosResponse<ApiResponse<AdminRecordingWatchResponse>> =
        await client.get(`/admin/recordings/${recordingId}/watch`);
      return response.data.data;
    },
  };
}
